export class FileToBase64TextConverter {
  public static convert(file: File, onLoad: (param: string) => void, onError: () => void): void {
    const reader = new FileReader();
    reader.onload = () => {
      onLoad(this.arrayBufferToBase64(reader.result));
    };
    reader.onerror = () => {
      onError();
    };
    reader.readAsArrayBuffer(file);
  }

  private static arrayBufferToBase64(buffer: string | ArrayBuffer): string {
    if (typeof buffer === "string") {
      throw new Error("parameter type mismatch!!!");
    }
    // とりあえず暫定で以下のURLを参考にコードを移植している
    // https://stackoverflow.com/questions/9267899/arraybuffer-to-base64-encoded-string
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[ i ]);
    }
    return btoa(binary);
  }
}
